import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserTimes,
  faThumbsUp,
  faBolt,
} from "@fortawesome/free-solid-svg-icons";
import "../index.css";

export default function LandingPage(props) {
  return (
    <>
      <div className="">
        <div className="flex flex-wrap text-center justify-center pt-16">
          <div className="w-full lg:w-6/12 px-4">
            <h2 className="text-4xl text-sky-500">REIWA Forms Wizard</h2>
            <p className="text-lg leading-relaxed mt-4 mb-4">
              Welcome to the REIWA Forms Wizard to create Offer & Acceptance
              (O&A) forms for property transactions. This tool allows you to 
              download and print (<span className="font-bold">not complete electronically</span>) a certified "Contract for Sale of Land or Strata Title by Offer and Acceptance" related to any property in WA.
              The form cannot be downloaded with a blank property address field.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap mt-20 justify-center">
          <div className="w-full lg:w-3/12 px-4 text-center">
            <div className="p-4 w-16 h-16 shadow-lg bg-white rounded inline-flex items-center justify-center">
              <FontAwesomeIcon
                icon={faThumbsUp}
                size="2x"
                className="fill-current text-gray-600"
              />
            </div>
            <h6 className="text-xl mt-5 text-sky-500">Easy to Use</h6>
            <p className="mt-2 mb-4">
              Legally compliant, interactive, and user-friendly. Designed to
              give you peace of mind – and time back in your day.
            </p>
          </div>
          <div className="w-full lg:w-3/12 px-4 text-center">
            <div className="p-4 w-16 h-16 shadow-lg rounded bg-white inline-flex items-center justify-center">
              <FontAwesomeIcon
                icon={faUserTimes}
                size="2x"
                className="fill-current text-gray-600"
              />
            </div>
            <h5 className="text-xl mt-5 text-sky-500">No Subscription</h5>
            <p className="mt-2 mb-4">
              Simply enter the required details, pay a one-off fee and you're done. 
            </p>
          </div>
          <div className="w-full lg:w-3/12 px-4 text-center">
            <div className="p-4 w-16 h-16 shadow-lg rounded inline-flex bg-white items-center justify-center">
              <FontAwesomeIcon
                icon={faBolt}
                size="2x"
                className="fill-current text-gray-600"
              />
            </div>
            <h5 className="text-xl mt-5 text-sky-500">Fast</h5>
            <p className="mt-2 mb-4">
              Complete in less than 2 minutes. We'll provide you with a download
              link sent to you via email.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap mt-20 justify-center pb-8 lg:pb-0">
          <button
            className="container bg-sky-500 hover:bg-sky-800 text-white font-bold py-2 px-1 rounded-xl w-80"
            onClick={props.nextStep}
          >
            Let's get started
          </button>
        </div>
      </div>
    </>
  );
}
